// import external dependencies
import 'jquery'

// import local dependencies
import './modules'

// Google Maps JS
import './components/google-map'

import 'vh-variable'

import svg4everybody from 'svg4everybody'
svg4everybody()

import Tabby from 'tabbyjs'
if ($('[data-tabs]').length) new Tabby('[data-tabs]')

import Rellax from 'rellax'
if ($('.rellax').length) new Rellax('.rellax')

import 'jarallax/dist/jarallax.js'
$('.jarallax').jarallax({
  speed: 0.3,
})
